import { IProductsServiceGetResponseData } from '@modules/accounting-and-finance/interface/products-and-services/products-and-services.interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IProductsServiceGetResponseData[] = [];

export const ACCGProductsServices = createSlice({
  name: 'accgProductsServices',
  initialState,
  reducers: {
    setProductsServices: (
      _state,
      action: PayloadAction<IProductsServiceGetResponseData[]>,
    ) => {
      return [...action.payload];
    },
    removeProductsServices: () => {
      return initialState;
    },
  },
});

export default ACCGProductsServices.reducer;

export const { setProductsServices, removeProductsServices } =
  ACCGProductsServices.actions;
